import { HeaderActionBack, HeaderActionCustomerService, Header } from "@/components/Header"
import { Layout } from "@/components/Layout"

import { DynamicForm } from "../trade/components/DynamicForm"
import { formItems, formItems1,formItemsOut } from "./data"
import { useLogic } from "./useLogic";
import styles from './index.module.scss';
import { Block } from "@/components/Block";
import { CryptoTradeSteps } from "@/components/CryptoTradeSteps";

export const PageCryptoOrderDetail = () => {
  const logic = useLogic();
  return <Layout
    scrollable
    backgroundImage={false}
    header={
      <Header
        title={logic.orderInfo.passageType === "ChangeUsdt" ? "我的卖单":"我的买单"}
        leftActions={<HeaderActionBack />}
        rightActions={<HeaderActionCustomerService />}
      />
    }
  >
    <div className={styles.main}>
      <div className={styles.form} key={1}>
        <DynamicForm
          disabled={true}
          items={formItems}
          onRef={logic.onFormRef}
        />
      </div>
      <Block topline title="">
        {logic.orderInfo.createTime ? <CryptoTradeSteps
          status={logic.orderInfo.status}
          createTime={logic.orderInfo.createTime}
          passageType={logic.orderInfo.passageType}
        />: null}
      </Block>
    
      {
        logic.orderInfo.passageType !== "ChangeUsdt" ? (
          <>
            <div className={styles.qrCode}>
              {logic.orderInfo.receivingAddress ?
                <img className="QRcode" alt="qr code" />
                : null}
            </div>
            <div className={styles.tip}>
              <div className={styles.paymentType}>此地址只可接受 {logic.orderInfo.paymentType}</div>
            </div>
          </>
        ):null
      }
      
      <div className={styles.form} key={2}>
        <DynamicForm
          disabled={true}
          items={logic.orderInfo.passageType === "ChangeUsdt" ? formItemsOut : formItems1}
          onRef={logic.onFormRef1}
        />
      </div>
    </div>

  </Layout>
}